import React, { Component } from 'react';

import { Button, Modal, TextInputWithError } from '../uiold';
import { canUser } from '../../support/shared/permissionHelpers';
import { User } from '../../types/shared/User';

type Props = {
  internalNotes: string;
  onSave: (newValue: string) => void;
  onClose: () => void;
  user: User | null | undefined;
};

type State = {
  noteInput: string;
};

export default class NotesEditorModal extends Component<Props, State> {
  state: State = {
    noteInput: this.props.internalNotes,
  };

  render() {
    let { user } = this.props;
    if (!user || !canUser(user, { vendors: 'WRITE' })) {
      return null;
    }
    return (
      <Modal
        isVisible
        onClose={() => {
          this.props.onClose();
        }}
      >
        <Modal.Header title={t('Internal Notes')} />
        <Modal.Body>
          <TextInputWithError
            autoFocus={true}
            multiline={true}
            numberOfLines={10}
            placeholder={t('Internal notes, not visible to vendor')}
            style={{ height: 200, padding: 5 }}
            value={this.state.noteInput}
            onChangeText={(value) => {
              this.setState({ noteInput: value });
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            title={t('Save')}
            isPrimary
            onPress={() => {
              this.props.onSave(this.state.noteInput);
            }}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}
